module.exports = __webpack_public_path__ + "img/MassGIS 2011-2012.3c326829.png";